





























































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { shouldShowSportsDropdown } from '@/utils/routes.js';
import RoutesDifficultyDropdown from '~/components/partials/RoutesDifficultyDropdown.vue';
import RoutesCitiesDropdown from '~/components/partials/RoutesCitiesDropdown.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import MapOutline from '~/components/icons/MapOutline.vue';
import LocalisationRouteCard from '~/components/cards/LocalisationRouteCard.vue';
import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import LocalisationRoutesMobileModal from '~/components/lists/items/LocalisationRoutesMobileModal.vue';
import LabelsDropdown from "~/components/partials/LabelsDropdown.vue";
import SportsDropdown from "~/components/partials/SportsDropdown.vue";

const Modal = {
  MOBILE_ROUTE: 'routes',
};

@Component({
  components: {
    SportsDropdown,
    LabelsDropdown,
    RoutesDifficultyDropdown,
    CheckInput,
    MapOutline,
    LocalisationRouteCard,
    RoutesCitiesDropdown,
    CheckBoxesDropdown,
    LocalisationRoutesMobileModal,
  },
  computed: {
    ...mapState([
      'isMobileDownloadBannerDisplayed',
      'iframeMode',
    ]),
    ...mapState('explorer', [
      'displayLocalisationMap',
      'mobileLocalisationFiltersModal',
      'destinationRoutesFilters',
      'routesList',
      'destinationRoutes',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class LocalisationRoutes extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) sports: Types.SportItem[];
  @Prop(Array) routes: [];
  @Prop(Array) prefilledCities: string[];
  @Prop(Boolean) isExplorerView: false;

  $refs: {
    container: HTMLDivElement,
    routeTab: HTMLDivElement,
  }

  isMobileDownloadBannerDisplayed : boolean;
  displayLocalisationMap: boolean;
  mobileLocalisationFiltersModal: string;
  destinationRoutesFilters: {[key: string]: any};
  locale: string;
  routesList: Types.RouteList;
  destinationRoutes: Types.RouteList;

  Modal = Modal;
  modal: string = '';
  selectedLabels: Array<Types.LabelItem> = [];
  difficultyFilters: Array<number> = [];
  difficultyElevation: Array<number> = [];
  difficultyDistance: Array<number> = [];
  departureSelected: string | null = '';
  closedRoutes: boolean = false;
  minElevation: number = 0;
  maxElevation: number = 5000;
  minDistance: number = 0;
  maxDistance: number = 150;
  selectedTypes: Array<any> = [];

  routeTypes: Array<Types.CheckboxElement> = [
    { id: 'ROUTE', name: this.$t('localisationRoutes.types.route'), checked: false },
    { id: 'SPOT', name: this.$t('localisationRoutes.types.spot'), checked: false },
  ];

  calculatedDivHeight: number = 300;
  cantDoMore: boolean = false;
  declare iframeMode: boolean;

  get shouldShowSportsDropdown (): boolean {
    return shouldShowSportsDropdown(this.iframeMode, this.value);
  }

  handleInput (newValue: Array<Number | String>) {
    this.$emit('input', newValue);
  }

  emitHasScrolled () {
    const list: Types.RouteList = this.isExplorerView ? this.routesList : this.destinationRoutes;
    if (this.routes.length && (this.routes.length !== list.total)) {
      this.$emit('load-routes');
    }
  }

  @Emit('search-routes')
  searchRoutes () {
    this.$refs.container.scroll({ top: 0 });

    return {
      types: this.selectedTypes.map((t: Types.CheckboxElement) => t.id),
      difficulties: this.difficultyFilters,
      sport: this.value,
      label: this.selectedLabels?.map((s: Types.LabelItem) => s.id ? s.id : s),
      opened: this.closedRoutes,
      elevation_min: this.difficultyElevation.length ? this.difficultyElevation[0] : null,
      elevation_max: this.difficultyElevation.length ? this.difficultyElevation[1] === 5000 ? null : this.difficultyElevation[1] : null,
      distance_min: this.difficultyDistance.length ? this.difficultyDistance[0] * 1000 : null,
      distance_max: this.difficultyDistance.length ? this.difficultyDistance[1] === 150 ? null : this.difficultyDistance[1] * 1000 : null,
      routeCity: this.departureSelected || '',
    };
  }

  @Watch('mobileLocalisationFiltersModal')
  handleModalDisplay (val: string) {
    if (val === Modal.MOBILE_ROUTE) this.modal = Modal.MOBILE_ROUTE;
  }

  @Watch('destinationRoutesFilters')
  populate () {
    if (!this.cantDoMore) {
      if (this.destinationRoutesFilters.opened) this.closedRoutes = true;
      if (this.destinationRoutesFilters.sport) {
        this.destinationRoutesFilters.sport.map((s: string | number) => {
          const newValue = [...this.value];
          newValue.push(s);

          this.$emit('input', newValue);
        });
        this.$emit('input', [...new Set(this.value)]);
      }

      if (this.destinationRoutesFilters.routeCity) {
        this.departureSelected = this.destinationRoutesFilters.routeCity;
        this.filterRoutesByCity();
      }

      if (this.destinationRoutesFilters.types) {
        const types = this.routeTypes;
        this.destinationRoutesFilters.types.map((t: string) => {
          this.selectedTypes.push({ id: t });
          types.map((r: Types.CheckboxElement) => {
            if (r?.id === t) r.checked = true;
          });
        });
        this.routeTypes = types;
      }

      if (this.destinationRoutesFilters.difficulties) {
        this.difficultyFilters = this.destinationRoutesFilters.difficulties;
      }

      if (this.destinationRoutesFilters.elevation_min) this.minElevation = this.destinationRoutesFilters.elevation_min;

      if (this.destinationRoutesFilters.elevation_max) this.maxElevation = this.destinationRoutesFilters.elevation_max;

      this.difficultyElevation = [this.minElevation, this.maxElevation];

      if (this.destinationRoutesFilters.distance_min) this.minDistance = this.destinationRoutesFilters.distance_min / 1000;

      if (this.destinationRoutesFilters.distance_max) this.maxDistance = this.destinationRoutesFilters.distance_max / 1000;

      this.difficultyDistance = [this.minDistance, this.maxDistance];
    }

    this.cantDoMore = true;
  }

  get routeCities () {
    if (this.prefilledCities) return this.prefilledCities;
    const cities = [...new Set(this.routes.map((r: Types.Route) => r.start?.city))].sort();
    return cities.filter(c => c !== null);
  }

  mounted () {
    this.handleHeight();

    window.addEventListener('resize', this.handleHeight);

    this.$nuxt.$on('reset-queries', this.resetFilters);

    if (this.destinationRoutesFilters.label) {
      this.selectedLabels = this.destinationRoutesFilters.label;
    }

    this.populate();
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleHeight);
  }

  filterRoutesByCity () {
    this.$emit('filter-routes-by-cities', this.departureSelected);
  }

  handleModalClose () {
    this.modal = '';
    this.$store.commit('explorer/SET_MOBILE_LOCALISATION_FILTERS_MODAL', '');
  }

  /* eslint array-callback-return: 0 */
  populateFilterArray (data: any) {
    const self: any = this;
    const vueData: any = self[data.data];
    const isDuplicated: any = vueData.filter((item: any) => item.id === data.element.id).length === 1;
    if (!isDuplicated) {
      vueData.push(data.element);
    } else {
      vueData.map((filter: any, index: number) => {
        if (filter.id === data.element.id) {
          vueData.splice(index, 1);
        }
      });
    }
    return vueData.slice(0);
  }

  handleHeight () {
    if (this.$store.state.iframeMode) {
      this.calculatedDivHeight = this.$refs.routeTab.clientHeight;
    } else {
      this.calculatedDivHeight = this.$refs.routeTab.clientHeight +
        (this.$route.path.includes('/explorer/destinations/') ? 128 : 198);
    }
  }

  resetFilters () {
    /* eslint no-return-assign: 0 */
    const newSelectedSportsIds: (String | Number)[] = [];
    this.handleInput(newSelectedSportsIds);
    this.selectedLabels = [];
    this.difficultyFilters = [];
    this.difficultyElevation = [];
    this.difficultyDistance = [];
    this.departureSelected = '';
    this.selectedTypes = [];
    this.value = [];
    this.filterRoutesByCity();
    this.routeTypes.forEach((d: Types.CheckboxElement) => d.checked = false);
    this.closedRoutes = false;
    this.$root.$emit('reset-routes-ranges');
    this.$root.$emit('reset-checkboxes');
    this.$emit('reset-sports');
    this.$emit('reset-labels');
  }

  @Watch('value')
  watch () {
    this.$emit('input', this.value);
  }
}
